// extracted by mini-css-extract-plugin
module.exports = {"main":"Loader_main__XUBm1","loader":"Loader_loader__HSr1t","title":"Loader_title__3MWWg"};